<template>
  <div class="box">
    <div class="box_item title">有报考疑惑？在线客服随时解惑</div>
    <div>
      <img height="200" width="200" :src="info.picture" />
    </div>
    <div class="custom_mobile_text">客服电话：</div>
    <div class="custom_mobile">{{ info.title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    info: Object,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.box {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  height: 335px;
  text-align: center;
}

.title {
  color: #096dd9;
}

.box_item {
  text-align: center;
  height: 30px;
  line-height: 30px;
  padding: 10px;
  font-size: 16px;
}

.custom_mobile_text {
  font-size: 14px;
  padding: 10px;
}

.custom_mobile {
  padding: 10px;
  font-size: 20px;
  color: #096dd9;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/components/customer.vue